__turbopack_context__.v({
  "activityFilterDropdown": "TheMemes-module-scss-module__CYky5G__activityFilterDropdown",
  "artControls": "TheMemes-module-scss-module__CYky5G__artControls",
  "artControlsBalance": "TheMemes-module-scss-module__CYky5G__artControlsBalance",
  "artControlsCenter": "TheMemes-module-scss-module__CYky5G__artControlsCenter",
  "artControlsCenterGrouped": "TheMemes-module-scss-module__CYky5G__artControlsCenterGrouped",
  "artControlsCenterWithBalance": "TheMemes-module-scss-module__CYky5G__artControlsCenterWithBalance",
  "artControlsContent": "TheMemes-module-scss-module__CYky5G__artControlsContent",
  "artControlsFormatLabel": "TheMemes-module-scss-module__CYky5G__artControlsFormatLabel",
  "artFormatLabel": "TheMemes-module-scss-module__CYky5G__artFormatLabel",
  "artHeader": "TheMemes-module-scss-module__CYky5G__artHeader",
  "artHeaderContent": "TheMemes-module-scss-module__CYky5G__artHeaderContent",
  "artSlideButton": "TheMemes-module-scss-module__CYky5G__artSlideButton",
  "artSlideIcon": "TheMemes-module-scss-module__CYky5G__artSlideIcon",
  "arweaveLink": "TheMemes-module-scss-module__CYky5G__arweaveLink",
  "buttonIcon": "TheMemes-module-scss-module__CYky5G__buttonIcon",
  "disabled": "TheMemes-module-scss-module__CYky5G__disabled",
  "hodlersTable": "TheMemes-module-scss-module__CYky5G__hodlersTable",
  "hodlersTableLive": "TheMemes-module-scss-module__CYky5G__hodlersTableLive",
  "leaderboardNavigationLeft": "TheMemes-module-scss-module__CYky5G__leaderboardNavigationLeft",
  "leaderboardNavigationRight": "TheMemes-module-scss-module__CYky5G__leaderboardNavigationRight",
  "main": "TheMemes-module-scss-module__CYky5G__main",
  "mainContainer": "TheMemes-module-scss-module__CYky5G__mainContainer",
  "marketplace": "TheMemes-module-scss-module__CYky5G__marketplace",
  "memePageTab": "TheMemes-module-scss-module__CYky5G__memePageTab",
  "memePageTabActive": "TheMemes-module-scss-module__CYky5G__memePageTabActive",
  "memesCarousel": "TheMemes-module-scss-module__CYky5G__memesCarousel",
  "nftImagePadding": "TheMemes-module-scss-module__CYky5G__nftImagePadding",
  "nftImageWrapper": "TheMemes-module-scss-module__CYky5G__nftImageWrapper",
  "overviewColumn": "TheMemes-module-scss-module__CYky5G__overviewColumn",
  "overviewColumnNote": "TheMemes-module-scss-module__CYky5G__overviewColumnNote",
  "rankSubheading": "TheMemes-module-scss-module__CYky5G__rankSubheading",
  "rememesSortDropdown": "TheMemes-module-scss-module__CYky5G__rememesSortDropdown",
  "seasonDropdown": "TheMemes-module-scss-module__CYky5G__seasonDropdown",
  "sort": "TheMemes-module-scss-module__CYky5G__sort",
  "sortDirection": "TheMemes-module-scss-module__CYky5G__sortDirection",
  "tab": "TheMemes-module-scss-module__CYky5G__tab",
  "tabFocus": "TheMemes-module-scss-module__CYky5G__tabFocus",
  "tabFocusActive": "TheMemes-module-scss-module__CYky5G__tabFocusActive",
  "theArtImage": "TheMemes-module-scss-module__CYky5G__theArtImage",
  "viewAllLink": "TheMemes-module-scss-module__CYky5G__viewAllLink",
  "volumeDropdown": "TheMemes-module-scss-module__CYky5G__volumeDropdown",
  "volumeDropdownEnabled": "TheMemes-module-scss-module__CYky5G__volumeDropdownEnabled",
});
